<template>
  <v-card flat color="transparent">
    <v-card-title class="d-flex pa-0 justify-center text-center">
      <h1 class="event-info primary--text">{{ $t("event.title") }}</h1>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss" scoped>
.event-info {
  font-family: "Head";
  font-size: 36px;
  line-height: 1;  
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .event-info {
    font-size: 16px;    
  }
}
</style>
